'use strict';

import $ from 'jquery';
import Mustache from 'mustache';
import utils from '../util';
import getToken from '../api/token';
import {getShops} from '../api/shops';
//import {getUser} from '../api/users';
import Promise from 'bluebird';

export default function() {
	const $window = $(window);
	const $document = $(document);
	const $html = $('html');
	const $productForm = $('.v4-product-card form');
	const $dropShipping = $('.v4-product-drop-shipping');
	const template = $('#template-drop-shipping').html();

	const templateData = {
		inquiry: {},
		product: {},
		errors: {},
		loaders: {},
		stores: []
	};

	let shopsLoaded = false;
	let isActived = false;

	if ($dropShipping.length) {
		dropShippingEvents();
		productFormEvents();

		$(window).on('popstate', e => {
			closeDropShipping();
		});
	}

	/**
   * dropShippingEvents
   */
	function dropShippingEvents() {
		$dropShipping.appendTo('#intersport-page');

		$dropShipping
			.on('click', '.product-drop-shipping-close', closeDropShipping)
			.on('keyup invalid', '.drop-shipping-inquiry-form input', function() {
				const $this = $(this);
				$this.toggleClass('invalid', $this.is(':invalid'));
			})
			.on('submit', '.drop-shipping-inquiry-form', function(e) {
				processInquiryForm(e);
			});

		// Close drop shipping by clicking outside it or outside the product form
		$document.on('click', function(e) {
			if ($dropShipping.hasClass('transition-done') && !$(e.target).closest('.v4-product-drop-shipping, .product-colors, .product-sizes').length) {
				closeDropShipping();
			}
		});
	}

	function openDropShipping() {
		if ($productForm.find('[name="ean"]:checked').length) {
			storeScrollPosition($window);
			toggleDropShipping(true);
			if (!isActived) {
				isActived = true;
				$productForm.find('[name="ean"]:checked').trigger('change');
				setLoader('form', true);
				renderData();
			}
			if (typeof history !== 'undefined') {
				// push empty history entry to allow back button to close the panel
				history.pushState(null, '', '');
			}
			return true;
		}
		return false;
	}

	function closeDropShipping() {
		toggleDropShipping(false);
		restoreScrollPosition($window);
	}

	/**
	 * productFormEvents
	 */
	function productFormEvents() {
		$productForm
			.on('click', '.drop-shipping-button:not(.disabled)', function() {
				if ($productForm.find('[name="ean"]:checked').length) {
					openDropShipping();
				}
			})
			.on('change', '[name="color"]', function() {
				if (isActived) {
					updateProductData();
					renderData();
				}
			})
			.on('change', '[name="ean"]', function() {
				if (isActived) {
					updateProductData();
					renderData();
				}
			})
			.on('click', '[data-toggle="modal"]', function() {
				toggleDropShipping(false);
			});
	}

	/**
	 * updateProductData
	 */
	function updateProductData() {
		const $product = $('.v4-product');
		const $price = $('.v4-product-card .product-price-current');
		const $color = $productForm.find('[name="color"]:checked');
		const $size = $productForm.find('[name="ean"]:checked');

		templateData.product = {
			color: $color.data('name'),
			colorCode: $color.val(),
			ean: $size.closest('.product-sizes-list[data-color="' + $color.val() + '"]').length ? $size.val() : '',
			name: $productForm.data('brandName') + ' ' + $product.data('product-name'),
			category: $product.data('category'),
			sapTitlenumber: $productForm.data('sapTitlenumber'),
			size: $size.data('name'),
			price: $price.html(),
			image: $color.closest('.product-colors-list-item').find('img').attr('src').replace('c=system_150', 'c=system_1024x')
		};

	}

	/**
	 * processReservationForm
	 *
	 * @param {Object} e
	 */
	function processInquiryForm(e) {
		e.preventDefault();

		const $form = $dropShipping.find('.drop-shipping-inquiry-form');

		const $token = $form.find('input[name$="token"]');
		const $submit = $form.find('button[type="submit"]');
		const formErrorMessage = $form.data('formErrorText');

		$submit.prop('disabled', true);

		clearInquiryFormMessages();
		addInquiryFormLoader();

		if ($token.val()) {
			$.ajax({
				data: $.extend({ product: templateData.product }, $form.serializeObject()),
				dataType: 'json',
				method: 'POST',
				timeout: 30000,
				url: '/stage-ajax/dropShipping/'
			}).done(function(response) {
				if (response && response.result === 1) {
					templateData.inquiry.done = true;

					renderData();

				} else if (response && response.reason) {
					addInquiryFormMessage(response.reason, true);
				} else {
					addInquiryFormMessage(formErrorMessage, true);
				}
				if (response && response.formErrors) {
					showInquiryFormErrors(response.formErrors)
				}
			}).fail(function(xhr) {
				addInquiryFormMessage(formErrorMessage, true);

			}).always(function(response) {
				removeInquiryFormLoader();
				$form.find('input[name$="token"]').val('');
				$submit.prop('disabled', false);
			});
		} else {
			updateFormToken($form);
		}
	}

	/**
	 * setLoader
	 *
	 * @param {String} name
	 * @param {Boolean} state
	 */
	function setLoader(name, state) {
		if (name && typeof state !== 'undefined') {
			if (state) {
				templateData.loaders[name] = true;
			} else{
				delete templateData.loaders[name];
			}

			$dropShipping.toggleClass('is-loading', !!Object.keys(templateData.loaders).length);
		}
	}

	/**
	 * addFormMessage
	 *
	 * @param {String}  msg
	 * @param {Boolean} isError
	 */
	function addInquiryFormMessage(msg, isError) {
		clearInquiryFormMessages();

		$('<div>', { class: 'drop-shipping-info-block' + (isError ? ' is-error' : ''), text: msg }).appendTo($dropShipping.find('#drop-shipping-inquiry-form-alert-container'));
	}

	function showInquiryFormErrors(errors) {
		for (let id of errors) {
			id = '#drop-shipping-'+id;
			$dropShipping.find('.drop-shipping-inquiry-form '+id).addClass('has-error');
		}
	}

	/**
	 * clearInquiryFormMessages
	 */
	function clearInquiryFormMessages() {
		$dropShipping.find('.drop-shipping-inquiry-form .has-error').removeClass('has-error');
		$dropShipping.find('#drop-shipping-inquiry-form-alert-container').find('.drop-shipping-info-block').remove();
	}

	/**
	 * Add spinner loader to the page
	 */
	function addInquiryFormLoader() {
		removeInquiryFormLoader();

		$('<div>', { class: 'drop-shipping-loader' })
			.append($('<div>', { class: 'spinner-loader-circle' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle2' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle3' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle4' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle5' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle6' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle7' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle8' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle9' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle10' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle11' }))
			.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle12' }))
			.appendTo($dropShipping.find('#drop-shipping-inquiry-form-alert-container'));
	}

	/**
	 * Add Remove loader to the page
	 */
	function removeInquiryFormLoader() {
		$dropShipping.find('#drop-shipping-inquiry-form-alert-container').find('.drop-shipping-loader').remove();
	}

	/**
	 * toggleClickAndCollect
	 *
	 * @param {Boolean} show
	 */
	function toggleDropShipping(show = true) {
		if (show) {
			$dropShipping.one(utils.transitionDone(), function() {
				$dropShipping.addClass('transition-done');
			})
		} else {
			$dropShipping.removeClass('transition-done');
		}

		$html.toggleClass('v4-product-drop-shipping-open', show);
	}

	/**
	 * renderData
	 */
	function renderData() {
		const shopPromise = !shopsLoaded ? getShops().then(res => {
			templateData.stores.push({ storeId: '', name: 'Valitse'});

			for (let [id, store] of Object.entries(res.shops)) {
				templateData.stores.push({ storeId: id, ...store });
			}

			shopsLoaded = true;
		}) : Promise.resolve();

		Promise.all([shopPromise]).then(() => {
			setLoader('form', false);
			$('#drop-shipping-content').html(Mustache.render(template, templateData));
		});
	}

	/**
	 * storeScrollPosition
	 *
	 * @param {jQuery} $el
	 * @param {Number} [pos]
	 */
	function storeScrollPosition($el, pos = $el.scrollTop()) {
		$el.data('scrollPosition', pos);
	}

	/**
	 * restoreScrollPosition
	 *
	 * @param {jQuery} $el
	 */
	function restoreScrollPosition($el) {
		$el.scrollTop($el.data('scrollPosition'));

		$el.data('scrollPosition', 0);
	}

	/**
	 * Fetch new token for the form and auto submit it
	 *
	 * @param {jQuery} $form
	 */
	function updateFormToken($form) {
		const $fields = $('input[name$="token"]').val('');

		return getToken().then(function(response) {
			$fields.val(response);
			$('input[name="stage_token"]').val(response);
			if ($form) {
				$form.trigger('submit');
			}
		});
	}

}
